export const enum RolesEnum {
	ASSURE = 'assure',
	EMPLOYEUR = 'employeur',
	TEMOIN = 'temoin'
}
